import { buildPermission } from "portal/utils/auth";
import { Button, Card, CardContent, Typography } from "@mui/material";
import { classes, SMALL_SECRET_RAINBOW_BUTTON } from "portal/theme/theme";
import { MuiIcon } from "common/components/types";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { useTranslation } from "react-i18next";
import { withAuthorizationRequired } from "../auth/WithAuthorizationRequired";
import { withErrorBoundary } from "../ErrorBoundary";
import { WithSkeleton } from "../WithSkeleton";
import React, { FunctionComponent } from "react";

export interface SupportLinkProps {
  href: string;
  i18nKey: string;
  LinkIcon: MuiIcon;
}

interface SupportLinksCardProps {
  success: boolean;
  links: SupportLinkProps[];
}

const _SupportLinksCard: FunctionComponent<SupportLinksCardProps> = ({
  success,
  links,
}) => {
  const { t } = useTranslation();

  return (
    <WithSkeleton variant="rectangular" success={success}>
      <Card>
        <CardContent>
          <Typography variant="h6" className="mb-4">
            {t("views.fleet.robots.summary.supportLinks.title")}
          </Typography>
          <div className="flex flex-col gap-2">
            {links.map((link, index) => (
              <Button
                {...SMALL_SECRET_RAINBOW_BUTTON}
                LinkComponent="a"
                className={classes(
                  SMALL_SECRET_RAINBOW_BUTTON.className,
                  "flex gap-1"
                )}
                target="_blank"
                href={link.href}
                key={index}
              >
                <link.LinkIcon />
                <span className="group-hover:text-rainbow">
                  {t(link.i18nKey)}
                </span>
              </Button>
            ))}
          </div>
        </CardContent>
      </Card>
    </WithSkeleton>
  );
};

export const SupportLinksCard = withErrorBoundary(
  {},
  withAuthorizationRequired(
    buildPermission(
      PermissionAction.read,
      PermissionResource.shortcuts_internal,
      PermissionDomain.all
    ),
    _SupportLinksCard
  )
);
